import React, { Fragment, Component } from 'react';

import { Popover, Tooltip } from '@mui/material';

import FilterListOutlined from '@mui/icons-material/FilterListOutlined';
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import tobeor from 'tobeor';
import moment from 'moment';

import Filters from '../../Filters';
import Sorters from '../../Sorters';
import ArrowTooltipCss from '../../ArrowTooltipCss';
import {
  isRestrictionOverriden,
  getFilterRstTitle,
  isFilterHasValues,
  getColumnTitle,
  getColumnId
} from '../../../utils';

import { HighlightedTableCell } from './TableHighlighting';
export default class TrplsTableHeadCell extends Component {
  state = {
    menu: false,
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  };

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  };

  handleClickOutside = (e) => {
    if (this.state.menu && this.wrapperRef && !this.wrapperRef.contains(e.target)) {
      this.toggleMenu(null);
    }
  };

  setWrapperRef(node) {
    this.wrapperRef = node;
  };

  toggleMenu = (menu) => {
    this.setState({ menu });
  };

  render() {
    const { menu } = this.state;

    const {
      rst,
      classes,
      isEmbed,
      tableId,
      scrolled,
      tableMenu,
      setSorters,
      ancestorId,
      individuals,
      searchValue,
      hideColumns,
      toggleColumn,
      togglePopover,
      initialSorters,
      filterRstValue,
      setFiltersToState,
      onFilterBtnClick,
      rstAddFilterClick,
      rstFilterNodeTitle,
      onFilterSearchElemClick,
    } = this.props;

    const columnTitle = getColumnTitle(rst);
    const rstChainId = getColumnId(rst);

    const cellFilter = rstChainId && tableMenu.filters.trpls
      // eslint-disable-next-line eqeqeq
      .find(filter => getFilterRstTitle(filter) === rstChainId.toString());

    const isCellFilterHasValue = cellFilter && isFilterHasValues(cellFilter);

    const isHiddenCol = hideColumns.includes(rstChainId);

    const theadRstId = rstChainId;

    const sort_pid = Array.isArray(rst.id) && rst.id.length > 1 ? rst.id.join('.')
      : Array.isArray(rst.id) ? rst.id[0] : rst.id || '';

    const popoverStyles = {
      marginTop: '10px',
      overflow: 'visible',
      boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16)',
    };

    const cellClassName = `${(
      classes.tableHeadCell
    )} ${classes.stickyCell} ${(
      classes.unselectable
    )} ${classes.relative} ${isHiddenCol ? classes.hiden : ''} ${(
      isEmbed ? classes.embeddedHeadCell : ''
    )}`;

    return (
      <HighlightedTableCell
        ref={(cell) => (this.cell = cell)}
        isHead={true}
        nodeId={null}
        tableId={tableId}
        ancestorId={ancestorId}
        rstChainId={rstChainId}
        cellClassName={cellClassName}
        classes={classes}
        resizable={true}
      >
        {isEmbed && rst.sid ? (
          <Popover
            id={`filters-popover-${theadRstId}`}
            anchorEl={tableMenu.filters.el}
            open={Boolean(tableMenu.filters.el) && tableMenu.rstId === theadRstId}
            PaperProps={{
              className: classes.glassBG,
              style: popoverStyles,
            }}
            onClose={() => togglePopover(null, 'filters')}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <Filters
              ancestor={rst.sid}
              callbacks={{
                onFilterBtnClick: onFilterBtnClick,
                setFiltersToParentState: setFiltersToState,
                onFiltersSearchNodeCb: onFilterSearchElemClick,
              }}
              rstDataMap={tableMenu.filters.rstDataMap}
              loaded={tableMenu.filters.isDataLoaded}
              filterBtnText="Filter"
              filterByNodeTitle={true}
              nodes={individuals.nodes}
              init={tableMenu.filters.init}
              initialSearchValue={searchValue}
              initialFilters={tableMenu.filters.initialFilters}
            />
          </Popover>
        ) : null}

        {isEmbed && rst.sid ? (
          <Popover
            id={`sorters-popover-${theadRstId}`}
            anchorEl={tableMenu.sorter.el}
            open={Boolean(tableMenu.sorter.el) && tableMenu.rstId === theadRstId}
            PaperProps={{
              className: classes.glassBG,
              style: popoverStyles,
            }}
            onClose={() => togglePopover(null, 'sorter', theadRstId)}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <Sorters
              callbacks={{
                setSorters: setSorters,
              }}
              initialSorters={initialSorters}
              rstDataMap={tableMenu.filters.rstDataMap}
            />
          </Popover>
        ) : null}

        <div className={classes.tableHeadCellContent}>
          <div className={`${classes.column} ${classes.alignStart} ${classes.fw}`}>
            <span
              title={`${columnTitle ? columnTitle : ''} (${rstChainId ? rstChainId : '_'}) #${
                (rst.sid && individuals.nodes[rst.sid]) ? individuals.nodes[rst.sid].title : ''}`}
              className={`${classes.tableHeadRstTitle}`}
            >
              {isRestrictionOverriden(rst) ? <strike>{rst.column_title || rst.title}</strike>
                : columnTitle || ''}
            </span>
          </div>

          {filterRstValue !== undefined ? (
            <div className={classes.rstSearchFilter}>
              {`Filter: ${
                rst.type === 'OBJECT' ? rstFilterNodeTitle : filterRstValue === '' ? 'Empty' : filterRstValue
              }`}
            </div>
          ) : null}

          {!isEmbed && rst.sid ? (
            <div className={`${classes.rstStatusIcons} ${classes.alignStart}`} style={{ zIndex: 10 }}>
              {isCellFilterHasValue ? (
                <ArrowTooltipCss placement="bottom" text="Filtered">
                  <FilterListOutlined
                    className={classes.rstStatusIcon}
                    onClick={() => {
                      let el = isEmbed ? this.cell : document.querySelector('.filters-popover-btn');

                      togglePopover(el, 'filters', theadRstId);
                    }}
                  />
                </ArrowTooltipCss>
              ) : null}

              {(initialSorters.sort_pid === rstChainId &&
                initialSorters.sort_desc === false &&
                initialSorters.sort_by === 0) ||
              (initialSorters.sort_pid === rstChainId &&
                initialSorters.sort_desc === true &&
                initialSorters.sort_by === 1) ? (
                <ArrowTooltipCss placement="bottom" text="Sorted">
                  <KeyboardArrowDownOutlinedIcon
                    onClick={() => {
                      const sortersBtn = isEmbed ? this.cell : document.querySelector('.sorters-popover-btn');

                      togglePopover(sortersBtn, 'sorter', theadRstId);
                    }}
                    className={classes.rstStatusIcon}
                  />
                </ArrowTooltipCss>
              ) : (initialSorters.sort_pid === rstChainId &&
                  initialSorters.sort_desc === true &&
                  initialSorters.sort_by === 0) ||
                (initialSorters.sort_pid === rstChainId &&
                  initialSorters.sort_desc === false &&
                  initialSorters.sort_by === 1) ? (
                <ArrowTooltipCss placement="bottom" text="Sorted">
                  <KeyboardArrowUpOutlinedIcon
                    onClick={() => {
                      const sortersBtn = isEmbed ? this.cell : document.querySelector('.sorters-popover-btn');

                      togglePopover(sortersBtn, 'sorter', theadRstId);
                    }}
                    className={classes.rstStatusIcon}
                  />
                </ArrowTooltipCss>
              ) : null}
            </div>
          ) : null}

          {rst.type !== 'BUTTON' && rst.sid ? (
            <div
              style={{
                bottom: `${isEmbed ? 'auto' : ''}`,
                zIndex: 10,
              }}
              className={`${classes.alignCenter} ${classes.rstSortAndFilters}`}
            >
              {isEmbed ? (
                <div className={classes.alignCenter}>
                  {isCellFilterHasValue ? (
                    <Tooltip title="Filtered" placement="bottom" classes={{ tooltip: classes.theadEmbedTooltip }}>
                      <FilterListOutlined
                        className={classes.rstStatusIcon}
                        onClick={() => {
                          let el = isEmbed ? this.cell : document.querySelector('.filters-popover-btn');

                          togglePopover(el, 'filters', theadRstId);
                        }}
                      />
                    </Tooltip>
                  ) : null}

                  {(initialSorters.sort_pid === rstChainId &&
                    initialSorters.sort_desc === false &&
                    initialSorters.sort_by === 0) ||
                  (initialSorters.sort_pid === rstChainId &&
                    initialSorters.sort_desc === true &&
                    initialSorters.sort_by === 1) ? (
                    <Tooltip classes={{ tooltip: classes.theadEmbedTooltip }} title="Sorted" placement="top">
                      <KeyboardArrowDownOutlinedIcon
                        onClick={() => {
                          const sortersBtn = isEmbed ? this.cell : document.querySelector('.sorters-popover-btn');

                          togglePopover(sortersBtn, 'sorter', theadRstId);
                        }}
                        className={classes.rstStatusIcon}
                      />
                    </Tooltip>
                  ) : (initialSorters.sort_pid === rstChainId &&
                      initialSorters.sort_desc === true &&
                      initialSorters.sort_by === 0) ||
                    (initialSorters.sort_pid === rstChainId &&
                      initialSorters.sort_desc === false &&
                      initialSorters.sort_by === 1) ? (
                    <Tooltip
                      title="Sorted"
                      placement="top"
                      classes={{
                        tooltip: classes.theadEmbedTooltip,
                      }}
                    >
                      <KeyboardArrowUpOutlinedIcon
                        onClick={() => {
                          const sortersBtn = isEmbed ? this.cell : document.querySelector('.sorters-popover-btn');

                          togglePopover(sortersBtn, 'sorter', theadRstId);
                        }}
                        className={classes.rstStatusIcon}
                      />
                    </Tooltip>
                  ) : null}
                </div>
              ) : null}

              <ArrowDropDownOutlinedIcon
                onClick={() => {
                  this.toggleMenu(this.arrowDropdown);
                }}
                className={`${classes.tableHeaderDropDownIcon}`}
                ref={(arrowDropdown) => (this.arrowDropdown = arrowDropdown)}
              />
            </div>
          ) : null}
        </div>

        <Popover
          anchorEl={menu}
          id={`menu-popover`}
          open={Boolean(menu)}
          PaperProps={{
            className: classes.glassBG,
          }}
          onClose={() => this.toggleMenu(null)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <div
            className={classes.tableMenuRow}
            onClick={() => {
              // TODO fix logic duplication here and on onFilterChange in Filters
              
              const todayByUTC = moment(new Date())
                .utcOffset(0)
                .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
                ._d.getTime();

              rstAddFilterClick(
                rst.chainTitle || rst.id,
                rst.type === 'BOOLEAN'
                  ? false
                  : tobeor(rst.type, ['DATE', 'DATE_AND_TIME', 'TIME'])
                    ? todayByUTC
                    : '',
                () => {
                  const el = isEmbed ? this.cell : document.querySelector('.filters-popover-btn');
                  togglePopover(el, 'filters', theadRstId);
                  this.toggleMenu(null);
                }
              );
            }}
          >
            <FilterListOutlined className={classes.tableMenuRowIcon} />
            Add filter
          </div>

          {rst.type !== 'OBJECT' ? (
            <Fragment>
              <div
                className={classes.tableMenuRow}
                onClick={(e) => {
                  setSorters({
                    sort_pid,
                    sort_by: 1,
                    sort_desc: false,
                  });

                  this.toggleMenu(null);
                }}
              >
                <KeyboardArrowUpOutlinedIcon className={classes.tableMenuRowIcon} />
                Sort A-Z
              </div>

              <div
                className={classes.tableMenuRow}
                onClick={() => {
                  setSorters({
                    sort_pid,
                    sort_by: 1,
                    sort_desc: true,
                  });

                  this.toggleMenu(null);
                }}
              >
                <KeyboardArrowDownOutlinedIcon className={classes.tableMenuRowIcon} />
                Sort Z-A
              </div>

              <div
                className={classes.tableMenuRow}
                onClick={() => {
                  setSorters({
                    sort_pid,
                    sort_by: 0,
                    sort_desc: true,
                  });

                  this.toggleMenu(null);
                }}
              >
                <KeyboardArrowUpOutlinedIcon className={classes.tableMenuRowIcon} />
                Sort New first
              </div>

              <div
                className={classes.tableMenuRow}
                onClick={() => {
                  setSorters({
                    sort_pid,
                    sort_by: 0,
                    sort_desc: false,
                  });

                  this.toggleMenu(null);
                }}
              >
                <KeyboardArrowDownOutlinedIcon className={classes.tableMenuRowIcon} />
                Sort Old first
              </div>
            </Fragment>
          ) : null}

          <div
            className={classes.tableMenuRow}
            onClick={() => {
              toggleColumn(rstChainId);
              this.toggleMenu(null);
            }}
          >
            <img
              alt="hide column icon"
              src="/images/visibility-off.svg"
              className={classes.tableMenuRowIcon}
              style={{
                width: '17px',
                height: '17px',
              }}
            />
            Hide column
          </div>
        </Popover>
      </HighlightedTableCell>
    );
  }
};
